<template>
  <zj-layout-container>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable" ref="container">
        <div class="demo-preview" style="text-align:left;">
          <fieldset>
            <legend>级联选择框</legend>
            <el-row>
              <el-cascader
                v-model="cascader_value"
                :options="cascader_options"
                :props="{label:'label',value:'value'}"
              ></el-cascader>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>Tab标签</legend>
            <el-row>
              <el-tabs tab-position="right" class="custom-tabs">
                <el-tab-pane label="用户管理">用户管理</el-tab-pane>
                <el-tab-pane label="配置管理">配置管理</el-tab-pane>
                <el-tab-pane label="角色管理">角色管理</el-tab-pane>
                <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
              </el-tabs>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>输入框</legend>
            <el-row>
              <el-input v-model="input" placeholder="请输入内容"></el-input>
              <el-input-number v-model="num" :min="1" :max="10" label="描述文字"></el-input-number>
            </el-row>
            <el-row>
              <el-input placeholder="请输入内容" v-model="input" :disabled="true"></el-input>
            </el-row>
            <el-row>
              <el-input placeholder="请输入内容" v-model="input" clearable></el-input>
            </el-row>
            <el-row>
              <el-input placeholder="请输入密码" v-model="input" show-password></el-input>
            </el-row>
            <el-row>
              <div class="demo-input-suffix">
                属性方式：
                <el-input placeholder="请选择日期" suffix-icon="el-icon-date" v-model="input1"></el-input>
                <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2"></el-input>
              </div>
              <div class="demo-input-suffix">
                slot 方式：
                <el-input placeholder="请选择日期" v-model="input3">
                  <i slot="suffix" class="el-input__icon el-icon-date"></i>
                </el-input>
                <el-input placeholder="请输入内容" v-model="input4">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </div>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>Select 选择框</legend>
            <el-row>
              <el-select v-model="selectValue" placeholder="请选择">
                <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>分页</legend>
            <el-row>
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="400"
              ></el-pagination>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>按钮:</legend>
            <el-row>
              <el-button>默认按钮</el-button>
              <el-button type="primary">主要按钮</el-button>
              <el-button type="success">成功按钮</el-button>
              <el-button type="info">信息按钮</el-button>
              <el-button type="warning">警告按钮</el-button>
              <el-button type="danger">危险按钮</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button plain>朴素按钮</el-button>
              <el-button type="primary" plain>主要按钮</el-button>
              <el-button type="success" plain>成功按钮</el-button>
              <el-button type="info" plain>信息按钮</el-button>
              <el-button type="warning" plain>警告按钮</el-button>
              <el-button type="danger" plain>危险按钮</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button round>圆角按钮</el-button>
              <el-button type="primary" round>主要按钮</el-button>
              <el-button type="success" round>成功按钮</el-button>
              <el-button type="info" round>信息按钮</el-button>
              <el-button type="warning" round>警告按钮</el-button>
              <el-button type="danger" round>危险按钮</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button icon="el-icon-search" circle></el-button>
              <el-button type="primary" icon="el-icon-edit" circle></el-button>
              <el-button type="success" icon="el-icon-check" circle></el-button>
              <el-button type="info" icon="el-icon-message" circle></el-button>
              <el-button type="warning" icon="el-icon-star-off" circle></el-button>
              <el-button type="danger" icon="el-icon-delete" circle></el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button disabled>默认按钮</el-button>
              <el-button type="primary" disabled>主要按钮</el-button>
              <el-button type="success" disabled>成功按钮</el-button>
              <el-button type="info" disabled>信息按钮</el-button>
              <el-button type="warning" disabled>警告按钮</el-button>
              <el-button type="danger" disabled>危险按钮</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button plain disabled>朴素按钮</el-button>
              <el-button type="primary" plain disabled>主要按钮</el-button>
              <el-button type="success" plain disabled>成功按钮</el-button>
              <el-button type="info" plain disabled>信息按钮</el-button>
              <el-button type="warning" plain disabled>警告按钮</el-button>
              <el-button type="danger" plain disabled>危险按钮</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button type="text">文字按钮</el-button>
              <el-button type="text" disabled>文字按钮</el-button>
              <el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button type="primary" icon="el-icon-edit"></el-button>
              <el-button type="primary" icon="el-icon-share"></el-button>
              <el-button type="primary" icon="el-icon-delete"></el-button>
              <el-button type="primary" icon="el-icon-search">搜索</el-button>
              <el-button type="primary">
                上传
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button-group>
                <el-button type="primary" icon="el-icon-arrow-left">上一页</el-button>
                <el-button type="primary">
                  下一页
                  <i class="el-icon-arrow-right el-icon--right"></i>
                </el-button>
              </el-button-group>
              <el-button-group>
                <el-button type="primary" icon="el-icon-edit"></el-button>
                <el-button type="primary" icon="el-icon-share"></el-button>
                <el-button type="primary" icon="el-icon-delete"></el-button>
              </el-button-group>
            </el-row>
            <hr />
            <el-row>
              <el-button type="primary" :loading="true">加载中</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button>默认按钮</el-button>
              <el-button size="medium">中等按钮</el-button>
              <el-button size="small">小型按钮</el-button>
              <el-button size="mini">超小按钮</el-button>
            </el-row>
            <hr />
            <el-row>
              <el-button round>默认按钮</el-button>
              <el-button size="medium" round>中等按钮</el-button>
              <el-button size="small" round>小型按钮</el-button>
              <el-button size="mini" round>超小按钮</el-button>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>链接:</legend>
            <el-row>
              <el-link href="https://element.eleme.io" target="_blank">默认链接</el-link>
              <el-link type="primary">主要链接</el-link>
              <el-link type="success">成功链接</el-link>
              <el-link type="warning">警告链接</el-link>
              <el-link type="danger">危险链接</el-link>
              <el-link type="info">信息链接</el-link>
            </el-row>
            <hr />
            <el-row>
              <el-link disabled>默认链接</el-link>
              <el-link type="primary" disabled>主要链接</el-link>
              <el-link type="success" disabled>成功链接</el-link>
              <el-link type="warning" disabled>警告链接</el-link>
              <el-link type="danger" disabled>危险链接</el-link>
              <el-link type="info" disabled>信息链接</el-link>
            </el-row>
            <hr />
            <el-row>
              <el-link :underline="false">无下划线</el-link>
              <el-link>有下划线</el-link>
            </el-row>
            <hr />
            <el-row>
              <el-link icon="el-icon-edit">编辑</el-link>
              <el-link>
                查看
                <i class="el-icon-view el-icon--right"></i>
              </el-link>
            </el-row>
          </fieldset>

          <fieldset>
            <legend>单选框</legend>
            <el-row>
              <el-radio v-model="radio" label="1">备选项</el-radio>
              <el-radio v-model="radio" label="2">备选项</el-radio>
            </el-row>
            <hr />
            <el-row>
              <el-radio disabled v-model="radio2" label="禁用">备选项</el-radio>
              <el-radio disabled v-model="radio2" label="选中且禁用">备选项</el-radio>
            </el-row>
            <hr />
            <el-row>
              <el-radio-group v-model="radio3">
                <el-radio :label="3">备选项</el-radio>
                <el-radio :label="6">备选项</el-radio>
                <el-radio :label="9">备选项</el-radio>
              </el-radio-group>
            </el-row>
            <hr />
            <el-row>
              <el-radio-group v-model="radio4">
                <el-radio-button label="上海"></el-radio-button>
                <el-radio-button label="北京"></el-radio-button>
                <el-radio-button label="广州"></el-radio-button>
                <el-radio-button label="深圳"></el-radio-button>
              </el-radio-group>
            </el-row>
            <hr />
            <el-row>
              <el-radio-group v-model="radio5" size="medium">
                <el-radio-button label="上海"></el-radio-button>
                <el-radio-button label="北京"></el-radio-button>
                <el-radio-button label="广州"></el-radio-button>
                <el-radio-button label="深圳"></el-radio-button>
              </el-radio-group>
            </el-row>
            <hr />
            <el-row>
              <el-radio-group v-model="radio6" size="small">
                <el-radio-button label="上海"></el-radio-button>
                <el-radio-button label="北京" disabled></el-radio-button>
                <el-radio-button label="广州"></el-radio-button>
                <el-radio-button label="深圳"></el-radio-button>
              </el-radio-group>
            </el-row>
            <hr />
            <el-row>
              <el-radio-group v-model="radio7" disabled size="mini">
                <el-radio-button label="上海"></el-radio-button>
                <el-radio-button label="北京"></el-radio-button>
                <el-radio-button label="广州"></el-radio-button>
                <el-radio-button label="深圳"></el-radio-button>
              </el-radio-group>
            </el-row>
            <hr />
            <el-row>
              <el-radio v-model="radio8" label="1" border>备选项1</el-radio>
              <el-radio v-model="radio8" label="2" border>备选项2</el-radio>
            </el-row>
            <hr />
            <el-row>
              <el-radio v-model="radio9" label="1" border size="medium">备选项1</el-radio>
              <el-radio v-model="radio9" label="2" border size="medium">备选项2</el-radio>
            </el-row>
            <hr />
            <el-row>
              <el-radio-group v-model="radio10" size="small">
                <el-radio label="1" border>备选项1</el-radio>
                <el-radio label="2" border disabled>备选项2</el-radio>
              </el-radio-group>
            </el-row>
            <hr />
            <el-row>
              <el-radio-group v-model="radio11" size="mini" disabled>
                <el-radio label="1" border>备选项1</el-radio>
                <el-radio label="2" border>备选项2</el-radio>
              </el-radio-group>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>多选框</legend>
            <el-row>
              <!-- `checked` 为 true 或 false -->
              <el-checkbox v-model="checked">备选项</el-checkbox>
            </el-row>
            <hr />
            <el-row>
              <el-checkbox v-model="checked1" disabled>备选项1</el-checkbox>
              <el-checkbox v-model="checked2" disabled>备选项</el-checkbox>
            </el-row>
            <hr />
            <el-row>
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="复选框 A"></el-checkbox>
                <el-checkbox label="复选框 B"></el-checkbox>
                <el-checkbox label="复选框 C"></el-checkbox>
                <el-checkbox label="禁用" disabled></el-checkbox>
                <el-checkbox label="选中且禁用" disabled></el-checkbox>
              </el-checkbox-group>
            </el-row>
            <hr />
            <el-row>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              >全选</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
              </el-checkbox-group>
            </el-row>
            <hr />
            <el-row>
              <el-checkbox-group v-model="checkedCities2" :min="1" :max="2">
                <el-checkbox v-for="city in cities2" :label="city" :key="city">{{city}}</el-checkbox>
              </el-checkbox-group>
            </el-row>
            <hr />
            <el-row>
              <el-row>
                <el-checkbox-group v-model="checkboxGroup1">
                  <el-checkbox-button v-for="city in cities3" :label="city" :key="city">{{city}}</el-checkbox-button>
                </el-checkbox-group>
              </el-row>
              <el-row>
                <el-checkbox-group v-model="checkboxGroup2" size="medium">
                  <el-checkbox-button v-for="city in cities3" :label="city" :key="city">{{city}}</el-checkbox-button>
                </el-checkbox-group>
              </el-row>
              <el-row>
                <el-checkbox-group v-model="checkboxGroup3" size="small">
                  <el-checkbox-button
                    v-for="city in cities3"
                    :label="city"
                    :disabled="city === '北京'"
                    :key="city"
                  >{{city}}</el-checkbox-button>
                </el-checkbox-group>
              </el-row>
              <el-row>
                <el-checkbox-group v-model="checkboxGroup4" size="mini" disabled>
                  <el-checkbox-button v-for="city in cities3" :label="city" :key="city">{{city}}</el-checkbox-button>
                </el-checkbox-group>
              </el-row>
            </el-row>
            <hr />
            <template>
              <el-row>
                <el-checkbox v-model="checked3" label="备选项1" border></el-checkbox>
                <el-checkbox v-model="checked4" label="备选项2" border></el-checkbox>
              </el-row>
              <el-row>
                <el-checkbox v-model="checked5" label="备选项1" border size="medium"></el-checkbox>
                <el-checkbox v-model="checked6" label="备选项2" border size="medium"></el-checkbox>
              </el-row>
              <el-row>
                <el-checkbox-group v-model="checkboxGroup5" size="small">
                  <el-checkbox label="备选项1" border></el-checkbox>
                  <el-checkbox label="备选项2" border disabled></el-checkbox>
                </el-checkbox-group>
              </el-row>
              <el-row>
                <el-checkbox-group v-model="checkboxGroup5" size="mini" disabled>
                  <el-checkbox label="备选项1" border></el-checkbox>
                  <el-checkbox label="备选项2" border></el-checkbox>
                </el-checkbox-group>
              </el-row>
            </template>
          </fieldset>
        </div>
      </div>
    </zj-layout-main>
    <el-dialog
      v-dialogDrag
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleDialogClose">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </zj-layout-container>
</template>
<script>
const cityOptions = ["上海", "北京", "广州", "深圳"];
export default {
  name: "ZjDemoPreview",
  controller: "UI",
  action: "Preview",
  data() {
    return {
      num: 1,
      input: "",
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      radio: 1,
      radio2: "选中且禁用",
      radio3: 3,
      radio4: "上海",
      radio5: "上海",
      radio6: "上海",
      radio7: "上海",
      radio8: "1",
      radio9: "1",
      radio10: "1",
      radio11: "1",
      checked: true,
      checked1: false,
      checked2: true,
      checkList: ["选中且禁用", "复选框 A"],
      checkAll: false,
      checkedCities: ["上海", "北京"],
      cities: [].concat(cityOptions),
      isIndeterminate: true,
      checkedCities2: ["上海", "北京"],
      cities2: [].concat(cityOptions),
      checkboxGroup1: ["上海"],
      checkboxGroup2: ["上海"],
      checkboxGroup3: ["上海"],
      checkboxGroup4: ["上海"],
      cities3: [].concat(cityOptions),
      checked3: true,
      checked4: false,
      checked5: false,
      checked6: true,
      checkboxGroup5: [],
      checkboxGroup6: [],
      selectOptions: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      selectValue: "",
      currentPage4: 4,
      cascader_value: [],
      tabVal: "report1",
      tabOptions: [
        {
          name: "report1",
          lable: "report1"
        },
        {
          name: "report2",
          lable: "report2"
        },
        {
          name: "report3",
          lable: "report3"
        }
      ],
      cascader_options: [
        {
          value: "zhinan",
          label: "指南",
          children: [
            {
              value: "shejiyuanze",
              label: "设计原则",
              children: [
                {
                  value: "yizhi",
                  label: "一致"
                },
                {
                  value: "fankui",
                  label: "反馈"
                },
                {
                  value: "xiaolv",
                  label: "效率"
                },
                {
                  value: "kekong",
                  label: "可控"
                }
              ]
            },
            {
              value: "daohang",
              label: "导航",
              children: [
                {
                  value: "cexiangdaohang",
                  label: "侧向导航"
                },
                {
                  value: "dingbudaohang",
                  label: "顶部导航"
                }
              ]
            }
          ]
        },
        {
          value: "zujian",
          label: "组件",
          children: [
            {
              value: "basic",
              label: "Basic",
              children: [
                {
                  value: "layout",
                  label: "Layout 布局"
                },
                {
                  value: "color",
                  label: "Color 色彩"
                },
                {
                  value: "typography",
                  label: "Typography 字体"
                },
                {
                  value: "icon",
                  label: "Icon 图标"
                },
                {
                  value: "button",
                  label: "Button 按钮"
                }
              ]
            },
            {
              value: "form",
              label: "Form",
              children: [
                {
                  value: "radio",
                  label: "Radio 单选框"
                },
                {
                  value: "checkbox",
                  label: "Checkbox 多选框"
                },
                {
                  value: "input",
                  label: "Input 输入框"
                },
                {
                  value: "input-number",
                  label: "InputNumber 计数器"
                },
                {
                  value: "select",
                  label: "Select 选择器"
                },
                {
                  value: "cascader",
                  label: "Cascader 级联选择器"
                },
                {
                  value: "switch",
                  label: "Switch 开关"
                },
                {
                  value: "slider",
                  label: "Slider 滑块"
                },
                {
                  value: "time-picker",
                  label: "TimePicker 时间选择器"
                },
                {
                  value: "date-picker",
                  label: "DatePicker 日期选择器"
                },
                {
                  value: "datetime-picker",
                  label: "DateTimePicker 日期时间选择器"
                },
                {
                  value: "upload",
                  label: "Upload 上传"
                },
                {
                  value: "rate",
                  label: "Rate 评分"
                },
                {
                  value: "form",
                  label: "Form 表单"
                }
              ]
            },
            {
              value: "data",
              label: "Data",
              children: [
                {
                  value: "table",
                  label: "Table 表格"
                },
                {
                  value: "tag",
                  label: "Tag 标签"
                },
                {
                  value: "progress",
                  label: "Progress 进度条"
                },
                {
                  value: "tree",
                  label: "Tree 树形控件"
                },
                {
                  value: "pagination",
                  label: "Pagination 分页"
                },
                {
                  value: "badge",
                  label: "Badge 标记"
                }
              ]
            },
            {
              value: "notice",
              label: "Notice",
              children: [
                {
                  value: "alert",
                  label: "Alert 警告"
                },
                {
                  value: "loading",
                  label: "Loading 加载"
                },
                {
                  value: "message",
                  label: "Message 消息提示"
                },
                {
                  value: "message-box",
                  label: "MessageBox 弹框"
                },
                {
                  value: "notification",
                  label: "Notification 通知"
                }
              ]
            },
            {
              value: "navigation",
              label: "Navigation",
              children: [
                {
                  value: "menu",
                  label: "NavMenu 导航菜单"
                },
                {
                  value: "tabs",
                  label: "Tabs 标签页"
                },
                {
                  value: "breadcrumb",
                  label: "Breadcrumb 面包屑"
                },
                {
                  value: "dropdown",
                  label: "Dropdown 下拉菜单"
                },
                {
                  value: "steps",
                  label: "Steps 步骤条"
                }
              ]
            },
            {
              value: "others",
              label: "Others",
              children: [
                {
                  value: "dialog",
                  label: "Dialog 对话框"
                },
                {
                  value: "tooltip",
                  label: "Tooltip 文字提示"
                },
                {
                  value: "popover",
                  label: "Popover 弹出框"
                },
                {
                  value: "card",
                  label: "Card 卡片"
                },
                {
                  value: "carousel",
                  label: "Carousel 走马灯"
                },
                {
                  value: "collapse",
                  label: "Collapse 折叠面板"
                }
              ]
            }
          ]
        },
        {
          value: "ziyuan",
          label: "资源",
          children: [
            {
              value: "axure",
              label: "Axure Components"
            },
            {
              value: "sketch",
              label: "Sketch Templates"
            },
            {
              value: "jiaohu",
              label: "组件交互文档"
            }
          ]
        }
      ],
      dialogVisible: false
    };
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleDialogClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.demo-preview {
  .el-row {
    margin: 1rem 1rem;
  }
  .el-input {
    max-width: 30rem;
    margin: 0.4rem 0.4rem;
  }
  .el-link {
    margin: 0.4rem 0.4rem;
  }
  hr {
    background: #ccc;
    border: none;
    border-bottom: solid 1px #333;
  }
  fieldset {
    margin: 1rem 1rem;
  }
}
</style>